import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { LocationAvailability } from "../../../features/Booking-Form/typings/booking-location";
import { GetBookingLocationParams } from "../../../features/Booking-Form/thunks/booking.thunks";

export function useRemoteFetchLocationAvailability(params?: GetBookingLocationParams) {
  const { t } = useTranslation();
  return useRemoteMutation<LocationAvailability[], RemoteApiError, GetBookingLocationParams>({
    key: ["allBookingLocations", JSON.stringify(params)],
    url: "/booking/availability/locations",
    snackbarTextOnFail: t("There was an error retrieving locations")
  });
}
